import Handlebars from 'handlebars';
import i18n from "i18next";

export default function () {
        var args = Array.prototype.slice.call(arguments);
        var code = args.shift();
        args.pop();
        var msg;
        if (args == null || args.length == 0) {
            msg = i18n.t(code);
        } else {
            msg = i18n.t[code];
            if (msg) {
                for (var i in args) {
                    msg = msg.replace("{" + i + "}", args[i]);
                }
            }
        }
        if (!msg || (msg.indexOf(".") != -1)) {
            console.log(code);
        }
        return msg ? new Handlebars.SafeString(msg) : msg;
};

/*
function setupHandlebars() {

    Handlebars.registerHelper("i18nd", function (code, options) {
        var msg = window.g_i18n[code], args = options.hash.arguments;
        if (msg && args) {
            for (var i in args) {
                msg = msg.replace("{" + i + "}", args[i]);
            }
        }
        if (!msg) {
            msg = options.hash["default"];
        }
        if (!msg) {
            msg = code;
        }
        return new Handlebars.SafeString(msg);
    });

    /!** equal helper **!/
    Handlebars.registerHelper('eq', function (a, b, options) {
        if (a == b) {
            return options.fn(this)
        } else {
            return options.inverse(this);
        }
    });

    /!** math helper **!/
    Handlebars.registerHelper('math', function (a, operator, b) {
        a = parseFloat(a);
        b = parseFloat(b);
        return {
            "+": a + b,
            "-": a - b,
            "*": a * b,
            "/": a / b
        }[operator];
    });
}*/



// WEBPACK FOOTER //
// ./src/hbHelpers/i18n.js